import React, { useEffect, useState } from 'react';
import { CheckCircle, Users, Heart } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { weddingData } from '../mockData';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const RSVP = () => {
  const { language } = useLanguage();
  const content = weddingData[language].rsvp;
  const [isVisible, setIsVisible] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    countryCode: '+33',
    phone: '',
    email: '',
    gender: '',
    attendance: 'yes',
    hasCompanion: false,
    companionFirstName: '',
    companionLastName: '',
    companionGender: '',
    guestCount: '1',
    message: ''
  });

  const countryCodes = [
    { code: '+33', country: 'FR', flag: '🇫🇷' },
    { code: '+225', country: 'CI', flag: '🇨🇮' },
    { code: '+1', country: 'US', flag: '🇺🇸' },
    { code: '+1', country: 'CA', flag: '🇨🇦' },
    { code: '+44', country: 'GB', flag: '🇬🇧' },
    { code: '+32', country: 'BE', flag: '🇧🇪' },
    { code: '+41', country: 'CH', flag: '🇨🇭' },
    { code: '+49', country: 'DE', flag: '🇩🇪' },
    { code: '+34', country: 'ES', flag: '🇪🇸' },
    { code: '+39', country: 'IT', flag: '🇮🇹' },
    { code: '+351', country: 'PT', flag: '🇵🇹' },
    { code: '+31', country: 'NL', flag: '🇳🇱' },
    { code: '+46', country: 'SE', flag: '🇸🇪' },
    { code: '+47', country: 'NO', flag: '🇳🇴' },
    { code: '+45', country: 'DK', flag: '🇩🇰' },
    { code: '+43', country: 'AT', flag: '🇦🇹' },
    { code: '+48', country: 'PL', flag: '🇵🇱' },
    { code: '+353', country: 'IE', flag: '🇮🇪' },
    { code: '+352', country: 'LU', flag: '🇱🇺' },
    { code: '+212', country: 'MA', flag: '🇲🇦' },
    { code: '+216', country: 'TN', flag: '🇹🇳' },
    { code: '+213', country: 'DZ', flag: '🇩🇿' },
    { code: '+221', country: 'SN', flag: '🇸🇳' },
    { code: '+223', country: 'ML', flag: '🇲🇱' },
    { code: '+224', country: 'GN', flag: '🇬🇳' },
    { code: '+226', country: 'BF', flag: '🇧🇫' },
    { code: '+227', country: 'NE', flag: '🇳🇪' },
    { code: '+228', country: 'TG', flag: '🇹🇬' },
    { code: '+229', country: 'BJ', flag: '🇧🇯' },
    { code: '+237', country: 'CM', flag: '🇨🇲' },
    { code: '+241', country: 'GA', flag: '🇬🇦' },
    { code: '+242', country: 'CG', flag: '🇨🇬' },
    { code: '+243', country: 'CD', flag: '🇨🇩' },
    { code: '+234', country: 'NG', flag: '🇳🇬' },
    { code: '+233', country: 'GH', flag: '🇬🇭' },
    { code: '+27', country: 'ZA', flag: '🇿🇦' },
    { code: '+254', country: 'KE', flag: '🇰🇪' },
    { code: '+55', country: 'BR', flag: '🇧🇷' },
    { code: '+52', country: 'MX', flag: '🇲🇽' },
    { code: '+86', country: 'CN', flag: '🇨🇳' },
    { code: '+81', country: 'JP', flag: '🇯🇵' },
    { code: '+82', country: 'KR', flag: '🇰🇷' },
    { code: '+91', country: 'IN', flag: '🇮🇳' },
    { code: '+61', country: 'AU', flag: '🇦🇺' },
    { code: '+971', country: 'AE', flag: '🇦🇪' },
    { code: '+966', country: 'SA', flag: '🇸🇦' },
    { code: '+90', country: 'TR', flag: '🇹🇷' },
    { code: '+7', country: 'RU', flag: '🇷🇺' },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setFormData(prev => ({
        ...prev,
        [name]: checked,
        ...(name === 'hasCompanion' && !checked ? { companionFirstName: '', companionLastName: '', companionGender: '' } : {})
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const submitData = {
        ...formData,
        phone: `${formData.countryCode} ${formData.phone}`,
        guestCount: formData.hasCompanion ? '2' : '1'
      };
      delete submitData.countryCode;
      if (!submitData.hasCompanion) {
        delete submitData.companionFirstName;
        delete submitData.companionLastName;
        delete submitData.companionGender;
      }
      const response = await axios.post(`${API}/rsvp`, submitData);
      console.log('RSVP Response:', response.data);
      setIsSubmitted(true);
      toast.success(content.success);
    } catch (error) {
      console.error('RSVP Error:', error);
      if (error.response && error.response.status === 409) {
        toast.error(
          language === 'fr'
            ? 'Cette adresse email a déjà été utilisée pour un RSVP.'
            : 'This email address has already been used for an RSVP.'
        );
      } else {
        toast.error(content.error);
      }
    }
  };

  if (isSubmitted) {
    return (
      <div className="min-h-screen pt-24 pb-20 flex items-center justify-center bg-ivory">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto text-center">
            <div className="card-premium p-12">
              <CheckCircle className="mx-auto text-gold-500 mb-6 animate-bounce drop-shadow-lg" size={80} />
              <h2 className="text-4xl font-playfair font-bold text-plum-900 mb-6">
                {language === 'fr' ? 'Merci !' : 'Thank You!'}
              </h2>
              <p className="text-xl text-plum-700 font-montserrat leading-relaxed mb-8">
                {content.success}
              </p>
              <button
                onClick={() => {
                  setIsSubmitted(false);
                  setFormData({
                    firstName: '',
                    lastName: '',
                    countryCode: '+33',
                    phone: '',
                    email: '',
                    gender: '',
                    attendance: 'yes',
                    hasCompanion: false,
                    companionFirstName: '',
                    companionLastName: '',
                    companionGender: '',
                    guestCount: '1',
                    message: ''
                  });
                }}
                className="btn-primary"
              >
                {language === 'fr' ? 'Nouvelle réponse' : 'New Response'}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-24 pb-20 bg-ivory">
      {/* Header - Plus de profondeur */}
      <section className="py-32 relative overflow-hidden" style={{
        background: 'linear-gradient(180deg, #F3EEF7 0%, #E5DDE9 35%, #CFC6D6 70%, #B5AAC0 100%)'
      }}>
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 left-20 w-64 h-64 bg-gold-300 rounded-full filter blur-3xl animate-float" />
          <div className="absolute bottom-20 right-20 w-64 h-64 bg-lilac-300 rounded-full filter blur-3xl animate-float" style={{ animationDelay: '2s' }} />
        </div>

        <div
          className={`container mx-auto px-6 sm:px-8 lg:px-12 text-center relative z-10 transition-all duration-1000 transform ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <Users className="mx-auto text-gold-500 mb-8 drop-shadow-lg" size={64} />
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-playfair font-bold text-plum-900 mb-6"
              style={{ textShadow: '0 2px 8px rgba(45,37,32,0.1)' }}>
            {content.title}
          </h1>
          <p className="text-xl text-plum-700 font-montserrat max-w-3xl mx-auto">
            {content.intro}
          </p>
          <div className="w-28 h-1 bg-gradient-to-r from-transparent via-gold-500 to-transparent mx-auto rounded-full mt-8"
               style={{ boxShadow: '0 1px 4px rgba(184,148,74,0.3)' }} />
        </div>
      </section>

      {/* Form Section */}
      <section className="py-20" style={{ background: 'linear-gradient(180deg, #F3EBE0 0%, #F8F4EE 100%)' }}>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            <form onSubmit={handleSubmit} className="card-premium p-8 sm:p-12">
              <div className="text-center mb-10">
                <Heart className="mx-auto text-gold-500 fill-gold-500 mb-4 drop-shadow" size={40} />
                <div className="divider-gold" />
              </div>

              {/* Registration Type - FIRST */}
              <div className="mb-8">
                <label className="block text-sm font-montserrat font-bold text-plum-800 mb-3">
                  {language === 'fr' ? 'Type d\'enregistrement' : 'Registration type'} *
                </label>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <label className="flex items-center p-4 border-2 border-lilac-200 rounded-xl cursor-pointer hover:border-gold-400 transition-all duration-300 has-[:checked]:border-gold-500 has-[:checked]:bg-gold-50 bg-surface"
                         style={{ boxShadow: '0 2px 8px rgba(45,37,32,0.06)' }}>
                    <input
                      type="radio"
                      name="registrationType"
                      value="single"
                      checked={!formData.hasCompanion}
                      onChange={() => setFormData(prev => ({ ...prev, hasCompanion: false, companionFirstName: '', companionLastName: '', companionGender: '' }))}
                      className="mr-3 accent-gold-500 w-5 h-5"
                      data-testid="registration-single"
                    />
                    <span className="font-montserrat text-plum-800 font-medium">
                      {language === 'fr' ? 'Vous êtes invité' : 'You are invited'}
                    </span>
                  </label>
                  <label className="flex items-center p-4 border-2 border-lilac-200 rounded-xl cursor-pointer hover:border-gold-400 transition-all duration-300 has-[:checked]:border-gold-500 has-[:checked]:bg-gold-50 bg-surface"
                         style={{ boxShadow: '0 2px 8px rgba(45,37,32,0.06)' }}>
                    <input
                      type="radio"
                      name="registrationType"
                      value="couple"
                      checked={formData.hasCompanion}
                      onChange={() => setFormData(prev => ({ ...prev, hasCompanion: true }))}
                      className="mr-3 accent-gold-500 w-5 h-5"
                      data-testid="registration-couple"
                    />
                    <span className="font-montserrat text-plum-800 font-medium">
                      {language === 'fr' ? 'Vous êtes un couple invité' : 'You are an invited couple'}
                    </span>
                  </label>
                </div>
              </div>

              {/* INVITÉ 1 */}
              <div className={`mb-6 ${formData.hasCompanion ? 'p-6 bg-lilac-50/30 rounded-2xl border border-lilac-100' : ''}`}>
                {formData.hasCompanion && (
                  <p className="text-sm font-montserrat font-bold text-gold-600 mb-4">
                    {language === 'fr' ? 'Invité(e) 1' : 'Guest 1'}
                  </p>
                )}

                {/* Gender */}
                <div className="mb-4">
                  <label className="block text-sm font-montserrat font-bold text-plum-800 mb-3">
                    {language === 'fr' ? 'Civilité' : 'Title'} *
                  </label>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <label className="flex items-center p-4 border-2 border-lilac-200 rounded-xl cursor-pointer hover:border-gold-400 transition-all duration-300 has-[:checked]:border-gold-500 has-[:checked]:bg-gold-50 bg-surface"
                           style={{ boxShadow: '0 2px 8px rgba(45,37,32,0.06)' }}>
                      <input
                        type="radio"
                        name="gender"
                        value="male"
                        checked={formData.gender === 'male'}
                        onChange={handleChange}
                        required
                        className="mr-3 accent-gold-500 w-5 h-5"
                        data-testid="gender-male"
                      />
                      <span className="font-montserrat text-plum-800 font-medium">
                        {language === 'fr' ? 'Monsieur' : 'Mr.'}
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-lilac-200 rounded-xl cursor-pointer hover:border-gold-400 transition-all duration-300 has-[:checked]:border-gold-500 has-[:checked]:bg-gold-50 bg-surface"
                           style={{ boxShadow: '0 2px 8px rgba(45,37,32,0.06)' }}>
                      <input
                        type="radio"
                        name="gender"
                        value="female"
                        checked={formData.gender === 'female'}
                        onChange={handleChange}
                        required
                        className="mr-3 accent-gold-500 w-5 h-5"
                        data-testid="gender-female"
                      />
                      <span className="font-montserrat text-plum-800 font-medium">
                        {language === 'fr' ? 'Madame' : 'Mrs.'}
                      </span>
                    </label>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-montserrat font-bold text-plum-800 mb-2">
                      {content.form.firstName} *
                    </label>
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3.5 border-2 border-lilac-200 rounded-xl focus:border-gold-500 focus:outline-none transition-all duration-300 font-montserrat bg-surface text-plum-800"
                      style={{ boxShadow: 'inset 0 2px 4px rgba(45,37,32,0.06)' }}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-montserrat font-bold text-plum-800 mb-2">
                      {content.form.lastName} *
                    </label>
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3.5 border-2 border-lilac-200 rounded-xl focus:border-gold-500 focus:outline-none transition-all duration-300 font-montserrat bg-surface text-plum-800"
                      style={{ boxShadow: 'inset 0 2px 4px rgba(45,37,32,0.06)' }}
                    />
                  </div>
                </div>
              </div>

              {/* INVITÉ 2 (Conjoint) */}
              {formData.hasCompanion && (
                <div className="mb-6 p-6 bg-lilac-50/30 rounded-2xl border border-lilac-100">
                  <p className="text-sm font-montserrat font-bold text-gold-600 mb-4">
                    {language === 'fr' ? 'Invité(e) 2' : 'Guest 2'}
                  </p>

                  <div className="mb-4">
                    <label className="block text-sm font-montserrat font-bold text-plum-800 mb-3">
                      {language === 'fr' ? 'Civilité' : 'Title'} *
                    </label>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <label className="flex items-center p-4 border-2 border-lilac-200 rounded-xl cursor-pointer hover:border-gold-400 transition-all duration-300 has-[:checked]:border-gold-500 has-[:checked]:bg-gold-50 bg-white"
                             style={{ boxShadow: '0 2px 8px rgba(45,37,32,0.06)' }}>
                        <input
                          type="radio"
                          name="companionGender"
                          value="male"
                          checked={formData.companionGender === 'male'}
                          onChange={handleChange}
                          required
                          className="mr-3 accent-gold-500 w-5 h-5"
                          data-testid="companion-gender-male"
                        />
                        <span className="font-montserrat text-plum-800 font-medium">
                          {language === 'fr' ? 'Monsieur' : 'Mr.'}
                        </span>
                      </label>
                      <label className="flex items-center p-4 border-2 border-lilac-200 rounded-xl cursor-pointer hover:border-gold-400 transition-all duration-300 has-[:checked]:border-gold-500 has-[:checked]:bg-gold-50 bg-white"
                             style={{ boxShadow: '0 2px 8px rgba(45,37,32,0.06)' }}>
                        <input
                          type="radio"
                          name="companionGender"
                          value="female"
                          checked={formData.companionGender === 'female'}
                          onChange={handleChange}
                          required
                          className="mr-3 accent-gold-500 w-5 h-5"
                          data-testid="companion-gender-female"
                        />
                        <span className="font-montserrat text-plum-800 font-medium">
                          {language === 'fr' ? 'Madame' : 'Mrs.'}
                        </span>
                      </label>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-montserrat font-bold text-plum-800 mb-2">
                        {content.form.firstName} *
                      </label>
                      <input
                        type="text"
                        name="companionFirstName"
                        value={formData.companionFirstName}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3.5 border-2 border-lilac-200 rounded-xl focus:border-gold-500 focus:outline-none transition-all duration-300 font-montserrat bg-white text-plum-800"
                        style={{ boxShadow: 'inset 0 2px 4px rgba(45,37,32,0.06)' }}
                        data-testid="companion-firstname"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-montserrat font-bold text-plum-800 mb-2">
                        {content.form.lastName} *
                      </label>
                      <input
                        type="text"
                        name="companionLastName"
                        value={formData.companionLastName}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3.5 border-2 border-lilac-200 rounded-xl focus:border-gold-500 focus:outline-none transition-all duration-300 font-montserrat bg-white text-plum-800"
                        style={{ boxShadow: 'inset 0 2px 4px rgba(45,37,32,0.06)' }}
                        data-testid="companion-lastname"
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Contact Info */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                {/* Phone */}
                <div className="overflow-hidden">
                  <label className="block text-sm font-montserrat font-bold text-plum-800 mb-2">
                    {content.form.phone} *
                  </label>
                  <div className="flex gap-2">
                    <select
                      name="countryCode"
                      value={formData.countryCode}
                      onChange={handleChange}
                      className="w-20 shrink-0 px-1 py-3.5 border-2 border-lilac-200 rounded-xl focus:border-gold-500 focus:outline-none transition-all duration-300 font-montserrat bg-surface text-plum-800 text-xs"
                      style={{ boxShadow: 'inset 0 2px 4px rgba(45,37,32,0.06)' }}
                      data-testid="country-code-select"
                    >
                      {countryCodes.map((c) => (
                        <option key={c.code + c.country} value={c.code}>
                          {c.flag} {c.code}
                        </option>
                      ))}
                    </select>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      placeholder="6 12 34 56 78"
                      className="min-w-0 flex-1 px-3 py-3.5 border-2 border-lilac-200 rounded-xl focus:border-gold-500 focus:outline-none transition-all duration-300 font-montserrat bg-surface text-plum-800"
                      style={{ boxShadow: 'inset 0 2px 4px rgba(45,37,32,0.06)' }}
                      data-testid="phone-input"
                    />
                  </div>
                </div>

                {/* Email */}
                <div>
                  <label className="block text-sm font-montserrat font-bold text-plum-800 mb-2">
                    {content.form.email} *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3.5 border-2 border-lilac-200 rounded-xl focus:border-gold-500 focus:outline-none transition-all duration-300 font-montserrat bg-surface text-plum-800"
                    style={{ boxShadow: 'inset 0 2px 4px rgba(45,37,32,0.06)' }}
                  />
                </div>
              </div>

              {/* Attendance */}
              <div className="mb-6">
                <label className="block text-sm font-montserrat font-bold text-plum-800 mb-3">
                  {content.form.attendance} *
                </label>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <label className="flex items-center p-4 border-2 border-lilac-200 rounded-xl cursor-pointer hover:border-gold-400 transition-all duration-300 has-[:checked]:border-gold-500 has-[:checked]:bg-gold-50 bg-surface"
                         style={{ boxShadow: '0 2px 8px rgba(45,37,32,0.06)' }}>
                    <input
                      type="radio"
                      name="attendance"
                      value="yes"
                      checked={formData.attendance === 'yes'}
                      onChange={handleChange}
                      className="mr-3 accent-gold-500 w-5 h-5"
                    />
                    <span className="font-montserrat text-plum-800 font-medium">
                      {formData.hasCompanion
                        ? (language === 'fr' ? 'Oui, nous serons présents' : 'Yes, we will attend')
                        : content.form.attendanceYes}
                    </span>
                  </label>
                  <label className="flex items-center p-4 border-2 border-lilac-200 rounded-xl cursor-pointer hover:border-gold-400 transition-all duration-300 has-[:checked]:border-gold-500 has-[:checked]:bg-gold-50 bg-surface"
                         style={{ boxShadow: '0 2px 8px rgba(45,37,32,0.06)' }}>
                    <input
                      type="radio"
                      name="attendance"
                      value="no"
                      checked={formData.attendance === 'no'}
                      onChange={handleChange}
                      className="mr-3 accent-gold-500 w-5 h-5"
                    />
                    <span className="font-montserrat text-plum-800 font-medium">
                      {formData.hasCompanion
                        ? (language === 'fr' ? 'Non, nous ne pourrons pas être présents' : 'No, we won\'t be able to attend')
                        : content.form.attendanceNo}
                    </span>
                  </label>
                </div>
              </div>

              {/* Message */}
              <div className="mb-8">
                <label className="block text-sm font-montserrat font-bold text-plum-800 mb-2">
                  {content.form.message}
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={4}
                  className="w-full px-4 py-3.5 border-2 border-lilac-200 rounded-xl focus:border-gold-500 focus:outline-none transition-all duration-300 font-montserrat resize-none bg-surface text-plum-800"
                  style={{ boxShadow: 'inset 0 2px 4px rgba(45,37,32,0.06)' }}
                  placeholder={language === 'fr' ? 'Laissez-nous un message...' : 'Leave us a message...'}
                />
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full btn-primary py-4 text-lg"
              >
                {content.form.submit}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RSVP;
